import { Eyebrow, Reveal } from "./Reveal";

const PILLARS = [
    "Class B & C Multifamily",
    "Value-Add Assets",
    "Sunbelt Markets",
    "Operational Turnarounds",
    "NOI Growth",
];

export default function Focus() {
    return (
        <section
            id="focus"
            data-testid="focus-section"
            className="bg-[#FAFAF9] py-24 lg:py-32"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
                <Reveal>
                    <Eyebrow dark>Our Focus</Eyebrow>
                    <h2 className="mt-6 font-display text-3xl font-extrabold tracking-tight text-[#0F172A] sm:text-4xl lg:text-5xl">
                        Where we create value.
                    </h2>
                </Reveal>
                <div className="mt-14">
                    {PILLARS.map((p, i) => (
                        <Reveal key={p} delay={i * 0.06}>
                            <div
                                data-testid={`focus-pillar-${i + 1}`}
                                className="group flex items-baseline justify-between gap-6 border-t border-slate-200 py-7 last:border-b hover:border-[#1BA8E0]/40"
                            >
                                <div className="flex items-baseline gap-6 sm:gap-10">
                                    <span className="font-display text-sm font-bold text-[#C5A059]">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    <span className="font-display text-2xl font-extrabold tracking-tight text-[#0F172A] transition-all duration-500 group-hover:translate-x-2 group-hover:text-[#1BA8E0] sm:text-4xl lg:text-5xl">
                                        {p}
                                    </span>
                                </div>
                                <span className="hidden h-2 w-2 rotate-45 bg-slate-300 transition-colors duration-500 group-hover:bg-[#1BA8E0] sm:block" />
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
